import { render } from "./TablaUsuarios.vue?vue&type=template&id=0ff92166&scoped=true"
import script from "./TablaUsuarios.vue?vue&type=script&lang=js"
export * from "./TablaUsuarios.vue?vue&type=script&lang=js"

import "./TablaUsuarios.vue?vue&type=style&index=0&id=0ff92166&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff92166"]])

export default __exports__